import * as  React from 'react';
import Wait from '../Assets/images/wait.svg';
import './ScreenSelection.scss';

export const ScreenSelection = () => {
	return <div className="ReportSummary-Content">
		<div className='ReportSummary-Content-Skeleton'>
			<div className='ReportSummary-Content-Image'>
				<img alt='presentation-wait' src={Wait} />
			</div>
			<div className='ReportSummary-Content-Message'>
				<div>
					<h2>
						Para una mejor búsqueda te invitamos a seleccionar una{' '}
						<span> minera y faena</span>
					</h2>
				</div>
			</div>
		</div>
	</div>
}
